import { inject } from 'aurelia-framework';
import { Redirect } from 'aurelia-router';
import { AuthService } from 'services/authService';
import { router } from 'aurelia-router';
import {AccountAPI} from 'services/accountAPI';
@inject(AuthService,AccountAPI)
@inject(router)
export class YTManager {

  constructor(authService) {
    this.authService = authService;
    this.authService.registerAccountChangeCallback(this.accountChange.bind(this));
    this.isWLAdmin = false;
    this.isYtmanager = false;
    this.isWhitelabel = false;
    this.isYTManager = false;
    this.whitelabelActive = true;
    this.supportEmail = null;
    this.dashboardlength = 'col-sm-9 right-area-content';
    this.logo_img = "images/magnfi-logo-small.png";
    this.logo_alt = "Magnfi Logo";
    this.isdashboard = false;
    this.dashboardlength = 'col-sm-12';
    this.rout = "";
    this.is_vendasta_user = false;
    this.rout =(localStorage.getItem('rout'))? localStorage.getItem('rout') : "";
    console.log("route param",this.rout);
    if(this.rout.includes("#/user/home") || this.rout == "#/user" || this.rout == "")
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9 right-area-content';
      console.log("Dashboard value is",this.isdashboard);
    }
    this.home_url = window.home_url;
    this.site_url = window.site_url;
    this.supportEmail = window.support_email;
    this.enable_plus = true;
    if(window.whitelabel) {
      this.whitelabel = window.whitelabel;
      this.footer_html = window.footer_html;
      this.logo_img = "api/whitelabel/getFile?file=site_logo";
      this.logo_alt = window.app_name + " Logo";
      this.tutorialUrl = window.tutorial_url;
      this.whitelabel_status = window.whitelabel_status;
      this.enable_plus = window.enable_plus;
    }

    if( this.authService.getUser().is_vendasta==1){
      this.is_vendasta_user=true;
      }

  }

  activate(model, route) {
    this.accountChange();
  }

  attached() {
    this.navMenu.addEventListener('blur', function(e) {this.navPanelClass = '';}.bind(this));
    this.setData();
  }

  accountChange() {
    const account = this.authService.getAccount();

    this.accountActive = account.status == '2'; // eslint-disable-line eqeqeq
    this.capture_key = account.link_id;

    if (account.logo_file !== null) {
      this.logoPath = 'api/account/getProfileImage?Authorization=' + this.authService.getUser().token + '&t=' + new Date();
    } else {
      this.logoPath = null;
    }

    if (this.authService.getUser().role === 'YTMANAGER') {
      this.isYtmanager = true;
    }

    if (this.authService.getUser().role === 'WLADMIN') {
      this.isWLAdmin = true;
    }

    if (this.authService.getUser().role === 'WLMANAGER') {
      this.isWLManager = true;
    }

    if( this.authService.getUser().is_vendasta==1){
      this.is_vendasta_user=true;
      }


    if (this.whitelabel) {
      if(this.isWLAdmin) {
        this.whitelabelActive = this.whitelabel_status == 0;
      } else {
        this.whitelabelActive = this.whitelabel_status < 2;
      }
    }

  }

  redirectToAdmin(){
    const user = JSON.parse(sessionStorage.getItem('magnfi_user'));
    window.location.href=`/admin-hub/sign-in?token=${user.token}&redirect_url=whitelabel-configuration/branding`
  }


  navigateLink(route, replace = false) {
    console.log("route param",route);
    localStorage.setItem('rout', route);
    if(route.includes("#/user/video/email"))
    {
      if(route.includes("upload"))
      route = route + "?captureType=3" + "?videoUpload=1";
      else
      route = route + "?captureType=3";
      // window.location.href = "Posts?Category=" + sel;
    }
    if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request")
    {
      this.isdashboard = true;
      this.dashboardlength = 'col-sm-12';
      console.log("Dashboard value is",this.isdashboard);
      // window.location.href = "Posts?Category=" + sel;
    }
    else
    {
      this.isdashboard = false;
      this.dashboardlength = 'col-sm-9 right-area-content';
      console.log("Dashboard value is",this.isdashboard);
    }

    this.router.navigate(route, { replace: replace });
    this.onNavigate();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  goToTutorials() {
    if(this.isWhitelabel) {
      window.open(this.tutorialUrl, '_blank');
    } else {
      this.navigateLink('#/user/tutorials');
    }

  }

  setData() {
    const account = this.authService.getAccount();

    this.site_url = window.site_url;

    this.biz_url = account.biz_url;
    this.bizUrl = this.biz_url;

    this.link_id = account.link_id;

    this.magnfiLink = this.site_url + '/biz/' + (account.biz_url ? account.biz_url : account.link_id);
    //this.magnfiLink = this.site_url + '/#/capture/link/' + account.link_id;
    this.visitVideoReviewPageParam = account.biz_url ? account.biz_url : account.link_id;

    console.log('linkssss=>',this.magnfiLink , this.visitVideoReviewPageParam);
    //this.videoReviewPage = this.site_url + '/#/capture/public/'+account.link_id;

    //Add integration script related to Vendasta
    let scriptURL = "//www.cdnstyles.com/static/product_navbar/v1/product_navbar.js";
    let scriptElement = document.createElement('script');



    console.log('V::',localStorage.getItem('tp_nav_url'), $('#product-navigation-bar-container').length );
    if(localStorage.getItem('tp_nav_url') && $('#product-navigation-bar-container').length == 0){
      console.log('V::',localStorage.getItem('tp_nav_url'), $('#product-navigation-bar-container').length );

        if(true){
            this.isdashboard = true;
            this.dashboardlength = 'col-sm-12';
            console.log("VDST:: 3" + this.isdashboard );
        }
        scriptElement.src = scriptURL;
        scriptElement.setAttribute("data-url", localStorage.getItem('tp_nav_url'));
        scriptElement.setAttribute("data-account-id", localStorage.getItem('tp_account_id'));
        scriptElement.setAttribute("data-app-id", localStorage.getItem('tp_app_id'));
        this.scriptElementInBody = document.querySelector('body').appendChild(scriptElement);
    }
    if( this.authService.getUser().is_vendasta==1){
      this.is_vendasta_user=true;
      }

    console.log('TPUSER1 '+ this.is_vendasta_user);

    //Add integration script related to Vendasta

    this.videoReviewPage = this.site_url + '/#/capture/public/' + (account.biz_url ? account.biz_url : account.link_id);

  }

  clickVideoCapturePage() {
    this.api.updateVideoReviewPageAccessCount(this.visitVideoReviewPageParam,()=>{
    }, ()=> {
    });
    window.open(this.magnfiLink, "_blank");
  }

  clickReviewPage() {
    window.open(this.videoReviewPage, "_blank");
  }

  logout() {
    localStorage.setItem('rout', '');
    this.authService.logout();
  }
  toggleMenu() {
    if (this.navPanelClass) {
      this.navPanelClass = '';
    } else {
      this.navPanelClass = 'visible';
      setTimeout(function() {
        this.navMenu.focus();
      }.bind(this), 100);
    }
  }

  onNavigate() {
    this.navPanelClass = '';
  }

  configureRouter(config, router) {
    this.router = router;
    //config.title = window.whitelabel ? window.site_title : 'Magnfi Your Site | Video Testimonials at the Click of a Link';


    config.map([
      { route: ['users'], name: 'users', moduleId: 'components/ytmanager/users', settings: { auth: true, ytmanager: true } },
      { route: ['user/:id'], name: 'user', moduleId: 'components/ytmanager/user', settings: { auth: true, ytmanager: true } },
      { route: ['user'], name: 'user', moduleId: 'components/ytmanager/user', settings: { auth: true, ytmanager: true } },
      { route: ['dashboard/:id'], name: 'dashboard', moduleId: 'components/ytmanager/userDashboard', settings: { auth: true, ytmanager: true } },
      { route: ['expertTipVideo/:userId'], name: 'expertTipVideo', moduleId: 'components/ytmanager/expertTipVideo', settings: { auth: true, ytmanager: true } },
      { route: ['expertTipVideo'], name: 'expertTipVideo', moduleId: 'components/ytmanager/expertTipVideo', settings: { auth: true, ytmanager: true } },
      { route: ['user/:id/videos'], name: 'videos', moduleId: 'components/ytmanager/videos', settings: { auth: true, ytmanager: true } },
      { route: ['videos/:account_owner_id'], name: 'videos', moduleId: 'components/ytmanager/videos', settings: { auth: true, ytmanager: true } },
      { route: ['userVideos'], name: 'userVideos', moduleId: 'components/ytmanager/userVideos', settings: { auth: true, ytmanager: true } },
      { route: ['video/expertTipVideo/:id'], name: 'brandVideo', moduleId: 'components/ytmanager/video', settings: { auth: true, ytmanager: true, brand_video: true} },
      { route: ['video/request/:id'], name: 'request', moduleId: 'components/ytmanager/video', settings: { auth: true, ytmanager: true } },
      { route: ['video/request/new/:account_owner_id'], name: 'newRequest', moduleId: 'components/ytmanager/video', settings: { auth: true, ytmanager: true } },
      { route: ['video/case/new/:account_owner_id'], name: 'newCaseStudy', moduleId: 'components/ytmanager/caseStudy', settings: { auth: true, ytmanager: true } },
      { route: ['video/case/:id'], name: 'caseStudy', moduleId: 'components/ytmanager/caseStudy', settings: { auth: true, adminytmanager: true } },
    
      // { route: ['smtp'], name: 'smtp', moduleId: 'components/ytmanager/smtpSetting', settings: { auth: true, ytmanager: true } },
      { route: ['video/link/:id'], name: 'submission', moduleId: 'components/ytmanager/video', settings: { auth: true, ytmanager: true, link_submission: true } },
      { route: ['video/brand/:id'], name: 'brandVideo', moduleId: 'components/ytmanager/video', settings: { auth: true, ytmanager: true, brand_video: true } },
      { route: ['video/email/:id'], name: 'videoEmail', moduleId: 'components/ytmanager/videoEmail', settings: { auth: true, ytmanager: true } },
      { route: ['video/message/:id'], name: 'videoEmail', moduleId: 'components/ytmanager/videoEmail', settings: { auth: true, ytmanager: true } },
      { route: ['video/case/new/:account_owner_id'], name: 'newCaseStudy', moduleId: 'components/ytmanager/caseStudy', settings: { auth: true, ytmanager: true } },
      { route: ['video/case/:id'], name: 'caseStudy', moduleId: 'components/ytmanager/caseStudy', settings: { auth: true, ytmanager: true } },
      { route: ['pricing'], name: 'pricing', moduleId: 'components/ytmanager/pricing', settings: { auth: true, ytmanager: true } },
      { route: ['wlrPricing'], name: 'wlrPricing', moduleId: 'components/ytmanager/wlrPricing', settings: { auth: true, ytmanager: true } },
      { route: ['coupons'], name: 'coupons', moduleId: 'components/ytmanager/coupons', settings: { auth: true, ytmanager: true } },

      { route: ['orgTypes'], name: 'orgTypes', moduleId: 'components/ytmanager/orgTypes', settings: { auth: true, ytmanager: true } },

      { route: ['payments'], name: 'payments', moduleId: 'components/ytmanager/payments', settings: { auth: true, ytmanager: true } },
      { route: ['payments/:user_id'], name: 'payments', moduleId: 'components/ytmanager/payments', settings: { auth: true, ytmanager: true } },
   


    ]);
    config.mapUnknownRoutes({ redirect: '#/' });
  }
}